<template>
  <v-container grid-list-xs class="pa-0 ma-0" fluid>
    <v-row class="pa-0 ma-0 titlesdark--text">
      <v-col md="8" sm="12" class="pa-0 ma-0 mt-1">
        <BreadCrumb :aItems="aItemsBreadcrumbs" :oattrs="{ class: 'ml-3' }" />
        <!-- <span class="pl-1 text-light font-size-2">{{ sTituloGrid }}</span> -->
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col md="12" sm="12" class="pa-0 ma-0">
        <v-tabs v-model="nTabSelect" active-class="active-item" class="mt-3 d-flex justify-start" background-color="background_tab" color="color_tab">
          <v-tab v-for="(oItem, index) in aTablas" :key="index" class="text-tab">
            {{ oItem.sTitulo }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="nTabSelect">
          <v-tab-item>
            <Historico /> 
          </v-tab-item>
        </v-tabs-items>        
      </v-col>
    </v-row>
  </v-container>
</template> 
<script>
import Historico from '@/views/Licencias/components/GridHistorico.vue'

export default {
  name: "HitoricoLicencias",
  components: { Historico },
  data() {
    return {
      nTabSelect: 0,
      sTituloGrid: this.$store.state.jsIdioma.oEquivalencias.ttlHistoricoLicencias,
      aTablas: [
        {
          sTableName: '',
          sTitulo: this.$store.state.jsIdioma.oEquivalencias.ttlHistoricoConexion,
        }
      ],
      aItemsBreadcrumbs: [
        {
          icon: "mdi-home-outline",
          disabled: false,
        },
        {
          text: this.$store.state.jsIdioma.oEquivalencias.ttlConfiguracion,
          disabled: true,
        },
        {
          text: this.$store.state.jsIdioma.oEquivalencias.ttlAdminLicencias,
          disabled: true,
        },
        {
          text: this.$store.state.jsIdioma.oEquivalencias.ttlHistoricoLicencias,
          disabled: true,
        },
      ],
    };
  }
};
</script>